export const CATEGORY_SECTION = 'Category Section';
export const MERCHANDISING_SECTION = 'Merchandising Section';
export const TOP_NAV_LEVEL = 'Top Nav Level 1';

export const TOP_NAV = 'TopNav';
